import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { useSelector } from "react-redux";
import { Checkbox, Icon } from "@blueprintjs/core";
import {
  getIdOrCodeOrIndex,
  isBottomRightCornerOfRectangle,
  PRIMARY_SELECTED_VAL
} from "./utils";
import { DropdownCell } from "./DropdownCell";
import { EditableCell } from "./EditableCell";
import { getVals } from "./getVals";
import { CellDragHandle } from "./CellDragHandle";
export const RenderCell = ({
  oldFunc,
  getCopyTextForCell,
  column,
  isCellEditable,
  isEntityDisabled,
  finishCellEdit,
  formName,
  noEllipsis,
  cancelCellEdit,
  getCellHoverText,
  selectedCells,
  isSelectionARectangle,
  startCellEdit,
  tableRef,
  onDragEnd,
  args
}) => {
  const editingCellSelector = (state) => state.form?.[formName]?.values?.reduxFormEditingCell;
  const shouldEditableCellInputBeClearedSelector = (state) => state.form?.[formName]?.values?.shouldEditableCellInputBeCleared;
  const editingCell = useSelector(editingCellSelector);
  const shouldEditableCellInputBeCleared = useSelector(
    shouldEditableCellInputBeClearedSelector
  );
  const [row] = args;
  const rowId = getIdOrCodeOrIndex(row.original, row.index);
  const cellId = `${rowId}:${row.column.path}`;
  const isEditingCell = editingCell === cellId;
  let val = oldFunc(...args);
  const oldVal = val;
  const text = getCopyTextForCell(val, row, column);
  const dataTest = {
    "data-test": "tgCell_" + column.path
  };
  const fullValue = row.original?.[row.column.path];
  if (isEditingCell) {
    if (column.type === "genericSelect") {
      const GenericSelectComp = column.GenericSelectComp;
      return /* @__PURE__ */ jsx(
        GenericSelectComp,
        {
          rowId,
          fullValue,
          initialValue: text,
          ...dataTest,
          finishEdit: (newVal, doNotStopEditing) => {
            finishCellEdit(cellId, newVal, doNotStopEditing);
          },
          dataTest,
          cancelEdit: cancelCellEdit
        }
      );
    }
    if (column.type === "dropdown" || column.type === "dropdownMulti") {
      return /* @__PURE__ */ jsx(
        DropdownCell,
        {
          isMulti: dataTest.isMulti || column.type === "dropdownMulti",
          initialValue: dataTest.initialValue || text,
          options: getVals(column.values),
          finishEdit: (newVal, doNotStopEditing) => {
            finishCellEdit(cellId, newVal, doNotStopEditing);
          },
          dataTest,
          cancelEdit: cancelCellEdit
        }
      );
    } else {
      return /* @__PURE__ */ jsx(
        EditableCell,
        {
          dataTest,
          cancelEdit: cancelCellEdit,
          isNumeric: column.type === "number",
          initialValue: shouldEditableCellInputBeCleared ? void 0 : text,
          finishEdit: (newVal) => {
            finishCellEdit(cellId, newVal);
          }
        }
      );
    }
  }
  const isBool = column.type === "boolean";
  if (isCellEditable && isBool) {
    val = /* @__PURE__ */ jsx(
      Checkbox,
      {
        disabled: isEntityDisabled(row.original),
        className: "tg-cell-edit-boolean-checkbox",
        checked: oldVal === "True",
        onChange: (e) => {
          const checked = e.target.checked;
          finishCellEdit(cellId, checked);
        }
      }
    );
    noEllipsis = true;
  }
  let title = text;
  if (getCellHoverText) title = getCellHoverText(...args);
  else if (column.getTitleAttr) title = column.getTitleAttr(...args);
  const isSelectedCell = selectedCells?.[cellId];
  const {
    isRect,
    selectionGrid,
    lastRowIndex,
    lastCellIndex,
    entityMap,
    pathToIndex
  } = isSelectionARectangle();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          ...!noEllipsis && {
            textOverflow: "ellipsis",
            overflow: "hidden"
          }
        },
        ...dataTest,
        className: "tg-cell-wrapper",
        "data-copy-text": text,
        "data-copy-json": JSON.stringify(
          //tnw: eventually we'll parse these back out and use either the fullValue (for the generic selects) or the regular text vals for everything else
          column.type === "genericSelect" ? {
            __strVal: fullValue,
            __genSelCol: column.path
          } : { __strVal: text }
        ),
        title: title || void 0,
        children: val
      }
    ),
    isCellEditable && (column.type === "dropdown" || column.type === "dropdownMulti" || column.type === "genericSelect") && /* @__PURE__ */ jsx(
      Icon,
      {
        icon: "caret-down",
        style: {
          position: "absolute",
          right: 5,
          opacity: 0.3
        },
        className: "cell-edit-dropdown",
        onClick: () => {
          startCellEdit(cellId);
        }
      }
    ),
    isSelectedCell && (isRect ? isBottomRightCornerOfRectangle({
      cellId,
      selectionGrid,
      lastRowIndex,
      lastCellIndex,
      entityMap,
      pathToIndex
    }) : isSelectedCell === PRIMARY_SELECTED_VAL) && /* @__PURE__ */ jsx(
      CellDragHandle,
      {
        thisTable: tableRef.current.tableRef,
        cellId,
        isSelectionARectangle,
        onDragEnd
      },
      cellId
    )
  ] });
};
